import { IFilterComponent, SearchFilter } from '../../../../infrastructure/iFilter-component';
import { OnInit, Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FilterService } from '../../../../services/filter.service';
import { AuthService } from '../../../../services/auth.service';
import { FilterRecordService } from '../../../../services/filter-record.service';
import { LogisticsService } from '../../../../services/logistics.service';

@Component({
  selector: 'app-send-study-report-logistics-filter',
  templateUrl: './send-study-report-logistics-filter.component.html',
  styleUrls: ['./send-study-report-logistics-filter.component.css']
})
export class SendStudyReportLogisticsFilterComponent implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;

  constructor(private formBuilder: FormBuilder
    , private filterService: FilterService
    , private authService: AuthService
    , private logisticsService: LogisticsService
    , private filterRecordService: FilterRecordService) {

    this.form = this.formBuilder.group({
      Name: [''],
      ShowSend: [false],
      ShowDeleted: [false],
    });
  }

  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('SendStudyReportLogisticsFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('SendStudyReportLogisticsFilterComponent', this.form);
  }

  async search(): Promise<any> {
    return await this.logisticsService.getStudyReportBatches(
      <boolean>this.form.controls.ShowDeleted.value
      , <boolean>this.form.controls.ShowSend.value
      , this.form.controls.Name.value
      , this.authService.getSectorId());
  }

  async ngOnInit() {

  }
}
